import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SiteMapStore } from '../../site-map.store';
import { holeFeatureIcon, holeStatusIcon } from '../../utils/hole-appearance';

@Component({
  selector: 'app-site-map-hole-legend',
  standalone: true,
  templateUrl: './hole-legend.component.html',
  styleUrls: ['./hole-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class SiteMapHoleLegendComponent {
  protected readonly store = inject(SiteMapStore);
  protected readonly statusIcon = holeStatusIcon;
  protected readonly featureIcon = holeFeatureIcon;

  protected readonly visible = computed(() => {
    const legends = this.store.holeLegends();
    const hasEntries = this.store.holeFeatureFilter() === 'all' ? legends.status.length > 0 : legends.feature.length > 0;
    return this.store.holesShown() && hasEntries;
  });

  protected featureLabel(feature: string): string {
    return feature.charAt(0).toUpperCase() + feature.slice(1);
  }
}
